/** `IonInput` 的外觀，樣式定義在 `@mobile/theme` 的 ionic-overrides.css。 */
export const FIELD_CLASS = 'app-field';
